import React from "react";
import Icons from "./Icons";
import { PLACEHOLDER_TEXT } from "./constants";

const EducationSection = ({
  section,
  updateSectionItem,
  removeSectionItem,
  addSectionItem,
}) => {
  const placeholders = PLACEHOLDER_TEXT.education;

  const getEmptyItem = () => ({
    degree: "",
    institution: "",
    period: "",
    details: "",
  });

  return (
    <div className="education-section">
      {section.items?.map((item) => (
        <div key={item.id} className="education-item">
          <button
            onClick={() => removeSectionItem(item.id)}
            className="item-remove-button"
            title="Remove education"
          >
            <Icons.X className="w-4 h-4" />
          </button>

          <div className="item-content">
            <div className="form-group">
              <label className="form-label">
                Degree/Certificate
                <span className="label-hint">
                  Include the full degree name and field of study
                </span>
              </label>
              <input
                type="text"
                value={item.degree || ""}
                onChange={(e) =>
                  updateSectionItem(item.id, { degree: e.target.value })
                }
                placeholder={placeholders.degree}
                className="form-input"
              />
            </div>

            <div className="form-row">
              <div className="form-group flex-1">
                <label className="form-label">Institution</label>
                <input
                  type="text"
                  value={item.institution || ""}
                  onChange={(e) =>
                    updateSectionItem(item.id, { institution: e.target.value })
                  }
                  placeholder={placeholders.institution}
                  className="form-input"
                />
              </div>

              <div className="form-group" style={{ width: "200px" }}>
                <label className="form-label">Period</label>
                <input
                  type="text"
                  value={item.period || ""}
                  onChange={(e) =>
                    updateSectionItem(item.id, { period: e.target.value })
                  }
                  placeholder={placeholders.period}
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                Additional Details
                <span className="label-hint">
                  Optional: GPA, honors, relevant coursework, etc.
                </span>
              </label>
              <textarea
                value={item.details || ""}
                onChange={(e) =>
                  updateSectionItem(item.id, { details: e.target.value })
                }
                placeholder={placeholders.details}
                className="form-textarea"
                rows={2}
              />
            </div>
          </div>
        </div>
      ))}

      <button
        onClick={() => addSectionItem(getEmptyItem())}
        className="add-item-button"
      >
        <Icons.Plus className="w-4 h-4" />
        Add Education
      </button>

      {section.items?.length === 0 && (
        <p className="empty-message">
          No education entries added yet. Add your degrees, certifications, or
          relevant training.
        </p>
      )}
    </div>
  );
};

export default EducationSection;
